import axios from 'axios'
import notifMessage from '@/translations/notifMessage.json'
import * as HELPERS from '@/utils/helpers'
import { InjectionKey } from 'vue'

export default class StatusCodeInterceptor {
  public enable() {
    axios.interceptors.response.use(
      (response) => {
        if (response.status === 200 || response.status === 201) {
          return Promise.resolve(response)
        } else {
          return Promise.reject(response)
        }
      },
      async (error) => {
        if (error.response && error.response.status) {
          switch (error.response.status) {
            case 400:
            case 401:
            case 502:
              HELPERS.showTopAlertMessage(true, 'error', error.message)
              break
            case 403:
              HELPERS.showTopAlertMessage(true, 'error', notifMessage.ERROR_ALERTS.FORBIDDEN)
              break
            case 404:
              HELPERS.showTopAlertMessage(
                true,
                'error',
                notifMessage.ERROR_ALERTS.PAGE_DOES_NOT_EXIST,
              )
              break
            case 429: {
              // Requests with skipRetryOn429 opt out of the global retry so the
              // caller can handle the indexing state directly (e.g. search view).
              if ((error.config as any)?.skipRetryOn429) {
                return Promise.reject(error.response)
              }
              const delay = 1000 * (error.response.headers['retry-after'] ?? 10)
              await new Promise((resolve) => setTimeout(resolve, delay))

              return axios(error.config)
            }
            case 500:
              HELPERS.showTopAlertMessage(
                true,
                'error',
                notifMessage.ERROR_ALERTS.SOMETHING_WENT_WRONG,
              )
              break
          }
          return Promise.reject(error.response)
        }
        HELPERS.showTopAlertMessage(true, 'error', notifMessage.ERROR_ALERTS.NETWORK_ERROR)
        return Promise.reject(error) // ← Handle network errors
      },
    )
  }
}

export const STATUS_CODE_INTERCEPTOR_KEY: InjectionKey<StatusCodeInterceptor> =
  Symbol('StatusCodeInterceptor')
